import { defineAsyncComponent } from 'vue';
import { mountApp, app } from '@/js/app-entries/app-entry-points/global';

const Converter = defineAsyncComponent(() => import('@/js/cryptocurrencies/converter/Converter.vue'));
const ChartWrapper = defineAsyncComponent(() => import('@/js/cryptocurrencies/ChartWrapper.vue'));
const ShareIcons = defineAsyncComponent(() => import('@/js/components/Tippy/ShareTippy/ShareIcons.vue'));
const HalvingCountdown = defineAsyncComponent(() => import('@/js/halving-pages/HalvingCountdown.vue'));
const TopExchangesTippy = defineAsyncComponent(() => import('@/js/components/Tippy/TopExchangesTippy/TopExchangesTippy.vue'));

app.component('Converter', Converter);
app.component('ChartWrapper', ChartWrapper);
app.component('ShareIcons', ShareIcons);
app.component('HalvingCountdown', HalvingCountdown);
app.component('TopExchangesTippy', TopExchangesTippy);

mountApp();
